import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "nes.css/css/nes.min.css";
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'rV1h8avr0GppKN0T8jrNOlGpf9i012My'
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
